<template>
    <div class="layout-topbar" :style="{ 'background': topbarColour() }">
        <button class="p-link layout-menu-button" @click="onMenuToggle">
            <span v-if="!isDesktop()" class="pi pi-bars" :class="textColor()"></span>
        </button>
        <!-- <div class="layout-topbar-icons">
			<span class="layout-topbar-search">
				<InputText type="text" placeholder="Search" />
				<span class="layout-topbar-search-icon pi pi-search"></span>
			</span>
			<button class="p-link">
				<span class="layout-topbar-item-text">Events</span>
				<span class="layout-topbar-icon pi pi-calendar"></span>
				<span class="layout-topbar-badge">5</span>
			</button>
			<button class="p-link">
				<span class="layout-topbar-item-text">Settings</span>
				<span class="layout-topbar-icon pi pi-cog"></span>
			</button>
			<button class="p-link">
				<span class="layout-topbar-item-text">User</span>
				<span class="layout-topbar-icon pi pi-user"></span>
			</button>
		</div> -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { db } from '@/firebase';

export default {
    data() {
        return {
            textDark: 'topbarLight',
            textLight: 'topbarDark'
        }
    },
    methods: {
        isDesktop() {
            return window.innerWidth > 1024;
        },
        onMenuToggle(event) {
            this.$emit('menu-toggle', event);
        },
        topbarColour() {
            let topbarColour = '#0388E5';
            if (this.client.primaryColour) {
                topbarColour =  '#' + this.client.primaryColour;
            }
            return topbarColour;
        },
        textColor() {
            // Get background color hex value. '#' is optional.
            let hex = '#0388E5';
            if(this.client.primaryColour) {
                hex = this.client.primaryColour;
            }
            
            let r = parseInt(hex.slice(0, 2), 16),
                g = parseInt(hex.slice(2, 4), 16),
                b = parseInt(hex.slice(4, 6), 16);

            // Return light or dark class based on contrast calculation
            return ((r * 0.299 + g * 0.587 + b * 0.114) > 186) ? this.textDark : this.textLight;
        }
    },
    firestore() {
        return {
            client: db.collection('clients').doc(this.user.data.client.key),
        }
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user"
        })
    }
}
</script>